import registerCardModal from "@/components/modal/RegisterCard/index.vue";
export default {
  metaInfo: {
    title: "결제수단",
  },
  components: {
    registerCardModal,
  },
  data() {
    return {
      modalStatus: {
        registerCardModal: false,
        registeredFrom: "PAGE",
      },
      myCards: [],
      parentCards: [],
      creditAvailable: false,
      type: null,
      isLoading: true,
    };
  },
  async mounted() {
    try {
      this.type = await this.$store.getters["auth/tokenPayload"]().type;
      this.getMyCard();
      if (this.type === "member") {
        this.getParentCard();
      }
    } catch (e) {
      await this.$store.dispatch("auth/signout");
      this.$router.push("/");
    }
  },

  methods: {
    //카드 삭제
    async deleteCard(billingId) {
      const confirmation = confirm("등록된 카드를 삭제할까요?");
      if (!confirmation) return;
      try {
        const result = await this.$store.dispatch(
          "payments/deleteCard",
          billingId
        );
        if (!result.success) {
          return alert("에러가 발생하였습니다");
        }
        alert("삭제가 완료되었습니다");
        return this.$router.go();
      } catch (e) {
        console.error(e);
        return alert("에러가 발생하였습니다");
      }
    },

    //개인 카드 정보 조회
    async getMyCard() {
      try {
        const result = await this.$store.dispatch("payments/myCard");
        if (result.success) {
          this.myCards = result.cards;

          if (this.type === "manager") {
            if (result.credit && result.credit._id) {
              this.creditAvailable = true;
            }
            this.isLoading = false;
          }
        } else return alert("에러가 발생하였습니다.");
      } catch (e) {
        console.error(e);
        return alert("에러가 발생하였습니다");
      }
    },

    //관리자 카드 정보 조회
    async getParentCard() {
      try {
        const isApproved = await this.checkApproved();
        if (isApproved) {
          const result = await this.$store.dispatch(
            "payments/getParentsBillings"
          );
          if (result.success) {
            this.parentCards = result.cards;
            if (result.credit && result.credit._id) {
              this.creditAvailable = true;
            }
          } else {
            return alert("에러가 발생했습니다.");
          }
          this.isLoading = false;
        } else {
          this.creditAvailable = false;
          return (this.isLoading = false);
        }
      } catch (e) {
        console.error(e);
        return alert("에러가 발생하였습니다");
      }
    },

    //승인 여부 확인
    async checkApproved() {
      try {
        const result = await this.$store.dispatch("users/biz_member_myInfo");
        if (result.success) {
          return (
            result.information.approved === "approved" &&
            result.information.parentStatus === "approved"
          );
        } else {
          return false;
        }
      } catch (e) {
        console.error(e);
        return alert("에러가 발생하였습니다");
      }
    },
  },
};
